import { createDynamicMiddleware } from '@reduxjs/toolkit'

export const dynamicMiddleware = createDynamicMiddleware()
